import { WebPageJsonLd } from "next-seo";
import { Platform } from "~/modules/platforms";
import { addBaseUrl } from "./addBaseUrl";
import { getPlatformURL } from "~/routes";

// // // //

export function getPlatformPageDescription(props: {
    platform: Platform;
}): string {
    const { platform } = props;

    return `Explore comprehensive insights on ${platform.name}, from issuer and network details to market cap, supply metrics, and transfer volumes. Analyze quantitative trends and asset-specific breakdowns for deeper insights.`;
}

// // // //

/**
 * Renders WebPage SEO metadata for the Protocol Individual page using the `ArticleJsonLd` component from `next-seo`.
 *
 * @param {Object} props - The component props.
 * @param {Article} props.protocol - The Protocol data used to generate SEO metadata.
 */
export function PlatformIndividualSEO(props: { platform: Platform }) {
    const { platform } = props;

    // Get yesterday's date
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    return (
        <WebPageJsonLd
            id={addBaseUrl(getPlatformURL({ platformSlug: platform.slug }))}
            description={getPlatformPageDescription({ platform })}
            lastReviewed={isoYesterday}
            reviewedBy={{
                type: "Organization",
                name: "RWA.xyz",
            }}
        />
    );
}
